import React from 'react';

interface ExternalLinkProps {
  url: string;
  className?: string;
}

export function ExternalLink({
  url,
  className,
  children,
}: React.PropsWithChildren<ExternalLinkProps>) {
  return (
    <a
      href={`https://${url?.replace(/^https?:\/\//, '').replace(/^www\./, '')}`}
      target="_blank"
      rel="noreferrer noopener"
      className={className}
    >
      {children}
    </a>
  );
}
